import React from 'react';
import Cafe from '../assets/images/cafe.png';
import Retail from '../assets/images/retail.png';
import MobileTaking from '../assets/images/mobiletaking.png';
import Restaurant from '../assets/images/restaurant.png';

function BusinessFeatures() {
  const features = [
    {
      image: Cafe,
      title: "Fast Order Processing",
      description: "Take orders quickly, reduce wait times, and serve more customers effortlessly."
    },
    {
      image: Restaurant,
      title: "Table Management",
      description: "Manage your restaurant's seating with ease. Assign tables, track orders, and enhance customer flow."
    },
    {
      image: Retail,
      title: "Send Order Direct To Kitchen",
      description: "Seamlessly send orders directly to the kitchen for faster prep times and fewer errors."
    },
    {
      image: MobileTaking,
      title: "Mobile Order Taking",
      description: "Empower your staff to take orders from anywhere in your venue."
    }
  ];

  return (
    <section className="py-16 px-4 bg-white">
      <div className="container mx-auto max-w-6xl text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-black mb-3">
          Powerful Features to Transform Your Business
        </h2>
        <p className="text-gray-700 mb-12 max-w-3xl mx-auto">
          From quick orders to in-depth analytics, VernPOS simplifies every aspect of your F&B operation.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <div key={index} className="overflow-hidden rounded-3xl relative group h-[400px] md:h-[400px] lg:h-[400px]">
              <img
                src={feature.image}
                alt={feature.title}
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent p-6 flex flex-col justify-end text-left">
                <h3 className="text-xl font-semibold text-white mb-2">{feature.title}</h3>
                <p className="text-white/80 text-sm">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

  );
}

export default BusinessFeatures;